import { Transform, Type } from 'class-transformer';
import { dateJSONTransformer } from '../../../_constants/validation-format-constants';

export class WFReimbursementRequestRawDto {
    reimbursementWorkflowId: number;
    communityId: number;
    status: string;
    sourceBankAccountId: number;
    targetBankAccountId: number;

    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    postDate: Date;

    description: string;
    amount: number;
    reimburseWorkflowIds: Array<number>;
}
